import React from 'react';
import {
  ConsentAnswer,
  consentAnswerOptions,
} from './VoiceTranscribingConsentOptions';

interface VoiceTranscribingServiceQuestionProps {
  value: ConsentAnswer;
  onChange: (value: ConsentAnswer) => void;
}

const VoiceTranscribingServiceQuestion: React.FC<
  VoiceTranscribingServiceQuestionProps
> = ({ value, onChange }) => {
  return (
    <div className="mt-2 govuk-bp:mt-5">
      <div className="govuk-form-group">
        <fieldset className="govuk-fieldset">
          <legend className="govuk-fieldset__legend govuk-fieldset__legend--l">
            <h1 className="govuk-fieldset__heading">
              Are you happy for the voice-to-text transcribing service to be
              used?
            </h1>
          </legend>

          <div className="govuk-radios" data-module="govuk-radios">
            {consentAnswerOptions.map(option => {
              const optionId = `voice-transcribing-service-${option.value}`;

              return (
                <div className="govuk-radios__item" key={option.value}>
                  <input
                    className="govuk-radios__input"
                    id={optionId}
                    name="happyForTranscribingService"
                    type="radio"
                    value={option.value}
                    checked={value === option.value}
                    onChange={() => onChange(option.value)}
                  />
                  <label
                    className="govuk-label govuk-radios__label"
                    htmlFor={optionId}
                  >
                    {option.label}
                  </label>
                </div>
              );
            })}
          </div>
        </fieldset>
      </div>
    </div>
  );
};

export default VoiceTranscribingServiceQuestion;
